<template>
	<div class="page boxBarcodePrint">
		<box fill>
			<el-form label-position="right" label-width="110px" class="EL-Form">
				<el-col :lg="5" :xl="5">
					<el-form-item label="订单编号" class="EL-Form-Item">
						<el-input v-model="mainSearch.orderCode" placeholder="请输入" @change="saveSearch()">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="物料编号" class="EL-Form-Item">
						<el-input v-model="mainSearch.matCode" placeholder="请输入" @change="saveSearch()">
						</el-input>
					</el-form-item>
				</el-col>
				<!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="项次" class="EL-Form-Item">
                        <el-input v-model="mainSearch.lineNo" placeholder="请输入" @change="saveSearch()">
                        </el-input>
                    </el-form-item>
                </el-col> -->
				<el-col :lg="5" :xl="5">
					<el-form-item label="供应商" class="EL-Form-Item">
						<el-input v-model="mainSearch.supplier" placeholder="请输入" @change="saveSearch()">
						</el-input>
					</el-form-item>
				</el-col>

				<el-col :lg="5" :xl="5">
					<el-form-item label="开始日期" class="EL-Form-Item">
						<el-date-picker
							v-model="mainSearch.beginTime"
							value-format="yyyy-MM-dd HH:mm"
							type="date"
							placeholder="开始日期"
							:picker-options="startPickerOptions"
						></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :lg="4" :xl="4">
					<el-form-item class="btn-edit-delete EL-Form-Item">
						<el-button class="btn-t-edit" @click="clickSelectList">
							查询
						</el-button>
						<el-button class="btn-t-delete" @click="reset">重置</el-button>
					</el-form-item>
				</el-col>
				<el-col :lg="5" :xl="5">
					<el-form-item label="结束日期" class="EL-Form-Item">
						<el-date-picker
							v-model="mainSearch.endTime"
							value-format="yyyy-MM-dd HH:mm"
							type="date"
							placeholder="结束日期"
							:picker-options="finishPickerOptions"
						></el-date-picker>
					</el-form-item>
				</el-col>
				<!-- <el-col :lg="5" :xl="5">
					<el-form-item label="选择打印模板" class="">
						<el-radio-group v-model="printTemplate" @change="printTemplateChange">
							<el-radio label="normal">标准</el-radio>
							<el-radio label="A5">A5</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col> -->
				<!-- <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="clickSelectList">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="reset">重置</el-button>
                    </el-form-item>
                </el-col> -->
			</el-form>
			<el-divider></el-divider>
			<plabel text="箱标签打印列表">
				<el-button
					v-authority="'BACK_MENU9_M5_B1'"
					class="btn-t-edit"
					type="primary"
					@click="boxBarcodePrintDialog = true"
					>箱标签打印</el-button
				>
                <el-button :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
			</plabel>
			<h-table
				:headerCellStyle="mainData.headerCellStyle"
				style="flex: 1"
				@pageChange="getBoxAttr"
				:data="boxMainData.data"
				pagination
				:nowPage.sync="boxMainData.nowPage"
				:pageSize.sync="boxMainData.pageSize"
				:total.sync="boxMainData.total"
				@selectionChange="selectAll"
				:summary-method="getSummaries"
				show-summary
			>
				<el-table-column label="工厂编号" prop="fcCode" align="center"> </el-table-column>
				<el-table-column label="订单编号" prop="orderCode" align="center"> </el-table-column>
				<!-- <el-table-column label="订单项次" prop="lineNo" align="center">
                </el-table-column> -->
				<el-table-column label="物料编号" prop="matCode" align="center"> </el-table-column>
				<el-table-column label="物料名称" prop="matName" align="center" width="150px"> </el-table-column>
				<el-table-column label="订单数量" prop="orderQuan" align="center"> </el-table-column>
				<el-table-column label="打印总数" prop="totalQuan" align="center"> </el-table-column>
				<el-table-column label="供应商" prop="supplier" align="center"> </el-table-column>
				<!-- <el-table-column label="供应商名称" prop="supplier" align="center">
                </el-table-column> -->
				<el-table-column label="每箱数量" prop="standNumber" align="center"> </el-table-column>
				<el-table-column label="打印标签张数" prop="printNumber" align="center"> </el-table-column>
				<el-table-column label="单张打印数量" prop="onePrintNumber" align="center">
				</el-table-column>
				<!-- <el-table-column label="累计打印数量" prop="sumPrintNumber" align="center">
                </el-table-column>
                <el-table-column label="未打印数量" prop="notPrintNumber" align="center">
                </el-table-column> -->
				<!-- <el-table-column label="物料二维码" prop="qrCode" align="center">
                </el-table-column> -->
				<el-table-column label="更新时间" prop="updateTime" align="center" min-width="130"> </el-table-column>
				<el-table-column label="创建时间" prop="createTime" align="center" min-width="130"> </el-table-column>
				<el-table-column label="操作人" prop="person" align="center"> </el-table-column>
				<el-table-column label="操作" min-width="120" fixed="right">
					<template slot-scope="scope">
						<!-- v-authority="'BACK_MENU9_M5_B3'" 暂不绑定-->
						<el-button
								v-authority="'BACK_MENU9_M5_B2'"
								class="btn-t-select"
								@click="showAuxiStockDetailDialog(scope.row)"
						>详情</el-button
						>
						<el-button
							type="danger"
							plain
							class="btn-t-select"
							@click="deleteHandle(scope.row.printId)"
							>删除</el-button
						>
					</template>
				</el-table-column>
			</h-table>
		</box>

		<!-- 详情 -->
		<el-dialog
			title="详情"
			:visible.sync="auxiStockDetailDialog"
			class="fromDialog"
			:style="$popups.popups(0.8, 0.8)"
		>
			<el-row>
				<el-col :lg="3" :xl="3" :offset="21" style="padding:10px 0">
					<el-button @click="print('normal')" class="btn-t-edit">标签打印</el-button>
					<el-button @click="print('A5')" class="btn-t-edit">A5打印</el-button>
					<!--原代码-->
					<!--                    <el-button @click="rePrintBarcode()" class="btn-t-edit">打印</el-button>-->
				</el-col>
				<!--打印效果预览-->
				<el-col :lg="3" :xl="3" :offset="21" style="padding:10px 0">
					<el-button @click="printLook('normal')" class="btn-t-edit">标签预览</el-button>
					<el-button @click="printLook('A5')" class="btn-t-edit">A5预览</el-button>
				</el-col>
			</el-row>

			<h-table
				:headerCellStyle="boxDetailData.headerCellStyle"
				:style="$popups.harvestRecordStyle(0.65)"
				:data="boxDetailData.data"
				@selectionChange="selectAllDetail"
			>
				<el-table-column type="selection" align="center"></el-table-column>
				<el-table-column label="箱号" prop="boxCode" align="center"> </el-table-column>
				<el-table-column label="订单编号" prop="orderCode" align="center"> </el-table-column>
				<el-table-column label="通道" prop="whCode" align="center"> </el-table-column>
				<el-table-column label="物料编号" prop="matCode" align="center"> </el-table-column>
				<el-table-column label="物料名称" prop="matName" align="center" width="150px"> </el-table-column>
				<el-table-column label="数量" prop="matQuan" align="center"> </el-table-column>
				<el-table-column label="供应商" prop="supplierRetrospectCode" align="center">
				</el-table-column>
				<el-table-column label="供应商名称" prop="supplier" align="center"> </el-table-column>
				<el-table-column label="批次" prop="batchNo" align="center"> </el-table-column>
				<el-table-column label="状态" prop="status" align="center"> </el-table-column>
				<el-table-column label="图纸版本号" prop="drawCode" align="center"> </el-table-column>
				<el-table-column label="供应商追溯号" prop="traceability" align="center"> </el-table-column>
				<el-table-column label="锻造供应商" prop="forgeSupplierCode" align="center">
				</el-table-column>
				<el-table-column label="锻造炉号" prop="forgeCode" align="center"> </el-table-column>
				<el-table-column label="钢材炉号" prop="rolledSteelCode" align="center"> </el-table-column>
				<el-table-column label="钢号" prop="steelCode" align="center"> </el-table-column>
				<el-table-column label="围板类型" prop="coamingType" align="center"> </el-table-column>
				<el-table-column label="公差" prop="specs" align="center"> </el-table-column>
				<el-table-column label="发货日期" prop="storeIssueTime" align="center"> </el-table-column>
				<!--<el-table-column label="生产日期" prop="matTime" align="center"> </el-table-column>-->
			</h-table>
			<div slot="footer" class="dialog-footer footer-bottom">
				<el-button @click="closeAuxiStockDetailDialog" type="info" size="mini">关 闭</el-button>
				<!-- <el-button :loading="insertAuxiStockMethods" @click="insertAuxiStockMethod" type="info">收 货</el-button> -->
			</div>
		</el-dialog>

		<!-- 箱标签打印 -->
		<el-dialog
			title="箱标签打印"
			:visible.sync="boxBarcodePrintDialog"
			class="fromDialog"
			:style="$popups.popups(0.8, 0.88)"
			:close-on-click-modal="false"
			:show-close="false"
		>
			<el-form
				label-position="right"
				label-width="120px"
				:model="boxPrintData"
				:rules="boxPrintDataRules"
				ref="deliveryInData"
				class="EL-Form"
			>
				<div class="title">订单详情</div>
				<el-col :lg="6" :xl="6">
					<el-form-item label="订单编号" prop="orderCode" class="EL-Form-Item">
						<el-input
							v-model="boxPrintData.orderCode"
							size="mini"
							@blur="getOrder(boxPrintData.orderCode)"
						>
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="6" :xl="6">
					<el-form-item label="物料编号" prop="lineNo" class="EL-Form-Item">
						<el-select
							v-model="boxPrintData.lineNo"
							filterable
							placeholder="请选择"
							size="mini"
							@change="getLineNo(boxPrintData.lineNo)"
						>
							<el-option
								v-for="item in lineNoList"
								:key="item.pdId"
								:label="item.matCode"
								:value="item.lineNo"
								>{{ item.matCode }}</el-option
							>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :lg="6" :xl="6">
					<el-form-item label="工厂编号" prop="fcCode" class="EL-Form-Item">
						<el-input v-model="boxPrintData.fcCode" size="mini" disabled> </el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="6" :xl="6">
					<el-form-item label="物料名称" prop="matName" class="EL-Form-Item">
						<el-input v-model="boxPrintData.matName" size="mini" disabled> </el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="6" :xl="6">
					<el-form-item label="供应商" prop="supplier" class="EL-Form-Item">
						<el-input v-model="boxPrintData.supplier" size="mini" disabled> </el-input>
					</el-form-item>
				</el-col>
				<!-- <el-col :lg="6" :xl="6">
                    <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.matCode" size="mini" disabled>
                        </el-input>
                    </el-form-item>
                </el-col> -->

				<el-col :lg="6" :xl="6">
					<el-form-item label="订单数量" prop="matQuan" class="EL-Form-Item">
						<el-input v-model="boxPrintData.matQuan" size="mini" disabled @change="createPrintQuan">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="6" :xl="6">
					<el-form-item label="订单剩余数量" prop="remainingNum" class="EL-Form-Item">
						<el-input v-model="boxPrintData.remainingNum" size="mini" disabled>
						</el-input>
					</el-form-item>
				</el-col>
				<!-- <el-col :lg="6" :xl="6">
					<el-form-item label="已收数量" prop="matArriveQuan" class="EL-Form-Item">
						<el-input v-model="boxPrintData.matArriveQuan" size="mini" disabled> </el-input>
					</el-form-item>
				</el-col>
				<el-col :lg="6" :xl="6">
					<el-form-item label="未收数量" prop="notReceivedNumber" class="EL-Form-Item">
						<el-input v-model="boxPrintData.notReceivedNumber" size="mini" disabled> </el-input>
					</el-form-item>
				</el-col> -->
				<!--<el-col :lg="6" :xl="6">
					<el-form-item label="生产日期" prop="matTime" class="EL-Form-Item">
						<el-date-picker
							v-model="boxPrintData.matTime"
							type="date"
							placeholder="选择日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-col>-->
				<el-col :lg="24" :xl="24">
					<hr style="margin-bottom:1%" />
				</el-col>
				<el-col :lg="24" :xl="24">
					<div class="title">打印信息</div>
				</el-col>
				<el-col :lg="6" :xl="6">
					<el-form-item label="每箱数量" prop="matStandNumber" class="EL-Form-Item">
						<!-- oninput="value=value.replace(/[^\d]/g,'')" -->
						<el-input-number
							v-model="boxPrintData.matStandNumber"
							size="mini"
							@change="createPrintQuan"
							:min="0"
						>
						</el-input-number>
					</el-form-item>
				</el-col>
				<el-col :lg="6" :xl="6">
					<el-form-item label="箱数" prop="printQuan" class="EL-Form-Item">
						<el-input-number
							v-model="boxPrintData.printQuan"
							oninput="value=value.replace(/[^\d]/g,'')"
							size="mini"
							:step="1"
							step-strictly
						>
						</el-input-number>
					</el-form-item>
				</el-col>
				<el-col :lg="6" :xl="6">
					<el-form-item label="单张打印数量" prop="onePrintQuan" class="EL-Form-Item">
						<!-- <el-select v-model="boxPrintData.onePrintQuan" placeholder="请选择" size="mini" >
                            <el-option key="1" label="1" value="1"></el-option>
                            <el-option key="2" label="2" value="2"></el-option>
                            <el-option key="3" label="3" value="3"></el-option>
                            <el-option key="4" label="4" value="4"></el-option>
                        </el-select> -->
						<el-input-number
							v-model="boxPrintData.onePrintQuan"
							placeholder="请输入"
							:step="1"
							step-strictly
							:min="1"
							:max="4"
						></el-input-number>
					</el-form-item>
				</el-col>
				<!-- <el-col :lg="6" :xl="6" >
                    <el-form-item label="累计打印数量" prop="numPrintQuan" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.numPrintQuan" size="mini" disabled>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="未打印数量" prop="noPrintQuan" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.noPrintQuan" size="mini" disabled>
                        </el-input>
                    </el-form-item>
                </el-col> -->
				<el-col :lg="24" :xl="24">
					<hr style="margin-bottom:1%" />
				</el-col>
				<el-col :lg="24" :xl="24">
					<div class="title">箱标签信息</div>
				</el-col>
				<!-- <div v-for="(item,index) in labelAttrList" :key="index">
                    <el-col :lg="6" :xl="6">
                        <el-form-item :label="item.labelName+''" prop="labelAttr">
                            <div v-for="(ele,i) in  boxPrintData.labelAttr" :key="i">
                                <el-input v-model="ele[index].value" :value="ele[i]" size="mini">
                                </el-input>
                            </div>
                        </el-form-item>
                    </el-col>
                </div> -->
				<div v-for="(item, index) in boxPrintData.labelAttr" :key="index">
					<el-col :lg="6" :xl="6">
						<el-form-item :label="item.labelName + ''" prop="labelAttr" class="EL-Form-Item">
							<el-date-picker
								v-if="item.type === 'date'"
								v-model="item.value"
								type="date"
								value-format="yyyy-MM-dd"
								placeholder="请选择"
							>
							</el-date-picker>
							<el-select
								v-else-if="item.type === 'select'"
								v-model="item.value"
								placeholder="请选择"
							>
								<el-option
									v-for="(ele, i) in item.options"
									:key="i"
									:label="ele.label"
									:value="ele.value"
								>
								</el-option>
							</el-select>
							<el-input
								v-else
								v-model="item.value"
								maxlength="20"
								:value="item[index]"
								size="mini"
								placeholder="请输入"
							>
							</el-input>
						</el-form-item>
					</el-col>
				</div>
				<el-col :lg="24" :xl="24">
					<hr style="margin-bottom:1%" />
				</el-col>
				<!-- <el-col :lg="24" :xl="24">
                    <div class="title">外协条码录入</div>
                </el-col>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="物料二维码" prop="matCodeQR" class="EL-Form-Item">
                        <el-input v-model="boxPrintData.matCodeQR" size="mini">
                        </el-input>
                    </el-form-item>
                </el-col> -->
			</el-form>
			<div slot="footer" class="dialog-footer footer-bottom">
				<el-button @click="colsePrint" type="info" size="mini">关 闭</el-button>
				<el-button @click="boxPrintBarcode" class="btn-t-edit" type="primary" size="mini"
					>保存并打印</el-button
				>
				<!--                <el-button @click="savePrint" class="btn-t-edit" type="primary" size="mini">保存并打印</el-button>-->
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { getLodop } from "../../libs/LodopFuncs.js";
import { printParamsFormat, printBoxBarcode } from '@/libs/printBoxBarcode'
import moment from "moment";
export default {
	name: "BoxBarcodePrint",
	data() {
		return {
			mainData: {
				data: [],
				nowPage: 1,
				pageSize: 50,
				total: 0,
				headerCellStyle: () => {
					return "background-color: #1f6cec";
				},
			},
			// 筛选条件
			mainSearch: {
				orderCode: "",
				lineNo: "",
				supplier: "",
				matCode: "",
				endTime: "",
				beginTime: "",
			},

			//全选
			checkList: [],
			//采购窗口
			insertAuxiStockDialog: false,
			//间材库入库详情窗口
			auxiStockDetailDialog: false,

			//箱标签打印
			boxBarcodePrintDialog: false,

			//阻盘明细对象集合
			auxiStockDetailData: {
				data: [],
				nowPage: 1,
				pageSize: 50,
				total: 0,
				headerCellStyle: () => {
					return "background-color: #1f6cec";
				},
			},
			//详情多选
			checkDetailList: [],
			// 工厂编号
			fcCode: localStorage.getItem("fcCode") || "",
			//操作人
			person: localStorage.getItem("user"),
			//操作人工号
			personNumber: localStorage.getItem("empNumber"),

			logContent: "", //操作日志-内容
			logRemarks: "", //操作日志-备注

			orderCode: "", //订单编号

			mtTypeList: [],

			//箱体打印信息
			barcodePrintData: {},

			downloadLoading: false, //下载中
			insertAuxiStockMethods: false,

			//箱标签打印
			boxPrintData: {
				orderCode: "",
				lineNo: "",
				supplier: "",
				matCode: "",
				matName: "",
				matQuan: "",
				matStandNumber: 0, //每箱箱数
				printQuan: 0,
				onePrintQuan: 1,
				numPrintQuan: "",
				noPrintQuan: "",
				labelAttr: [],
				matCodeQR: "",
				surplusQuan: "剩余数量",
				remainingNum: ''
			},
			lineNoList: [],
			orderPurchaseList: [],
			labelAttrList: [],

			boxAttrData: [],
			boxMainData: {
				data: [],
				nowPage: 1,
				pageSize: 50,
				total: 0,
				headerCellStyle: () => {
					return "background-color: #1f6cec";
				},
			},

			boxDetailData: {
				data: [],
				nowPage: 1,
				pageSize: 50,
				total: 0,
				headerCellStyle: () => {
					return "background-color: #1f6cec";
				},
			},

			boxPrintDataRules: {
				orderCode: [
					{
						required: true,
						message: "请输入",
						trigger: "blur",
					},
				],
				lineNo: [
					{
						required: true,
						message: "请选择",
						trigger: "blur",
					},
				],
				matStandNumber: [
					{
						required: true,
						message: "请输入",
						trigger: "blur",
					},
				],
				printQuan: [
					{
						required: true,
						message: "请输入",
						trigger: "blur",
					},
				],
				onePrintQuan: [
					{
						required: true,
						message: "请输入",
						trigger: "blur",
					},
				],
				labelAttr: [
					{
						required: true,
						message: "请输入",
						trigger: "blur",
					},
				],
				matTime: [
					{
						required: true,
						message: "请选择",
						trigger: "change",
					},
				],
			},

			//打印
			lazyNext: null,
			// 输入框延时加载
			isSetTimeout: null,
			// printTemplate: localStorage.getItem("printTemplate") || "normal",
		};
	},
	watch: {
		mainSearch: {
			handler(newVal) {
				clearTimeout(this.isSetTimeout);
				this.isSetTimeout = setTimeout(() => {
					this.getBoxAttr(newVal);
				}, 1000);
			},
			deep: true,
		},
	},
	computed: {
		startPickerOptions() {
			let _this = this;
			return {
				disabledDate(time) {
					if (_this.mainSearch.beginTime) {
						return time.getTime() > new Date(_this.mainSearch.beginTime);
					}
				},
			};
		},
		finishPickerOptions() {
			let _this = this;
			return {
				disabledDate(time) {
					if (_this.mainSearch.endTime) {
						return time.getTime() < new Date(_this.mainSearch.endTime);
					}
				},
			};
		},
	},
	methods: {
		BlurText(e) {
			let boolean = new RegExp("^[1-9][0-9]*$").test(e.target.value);
			if (!boolean) {
				this.$message.warning("请输入正整数");
				e.target.value = "";
			}
		},

		//复选框
		selectAll(val) {
			this.checkList = val;
		},
		//箱标签打印
		boxPrintBarcode() {
			// console.log(this.printTemplate)
			if (this.boxPrintData.matStandNumber == 0 || this.boxPrintData.matStandNumber == undefined) {
				this.$message({
					message: "请输入每箱箱数！",
					type: "warning",
				});
				return;
			}
			if (this.boxPrintData.printQuan == 0 || this.boxPrintData.printQuan == undefined) {
				this.$message({
					message: "请输入打印标签张数！",
					type: "warning",
				});
				return;
			}
			if (this.boxPrintData.onePrintQuan == 0 || this.boxPrintData.onePrintQuan == undefined) {
				this.$message({
					message: "请输入单张打印数量！",
					type: "warning",
				});
				return;
			}

			if (
				this.boxPrintData.matStandNumber * this.boxPrintData.printQuan >
				this.boxPrintData.matQuan
			) {
				this.$message({
					message: "打印数量超过计划数量",
					type: "warning",
				});
				return;
			}

			for (let i in this.boxPrintData.labelAttr) {
				if (this.boxPrintData.labelAttr[i].value == "") {
					this.$message({
						message: this.boxPrintData.labelAttr[i].labelName + "不能为空！",
						type: "warning",
					});
					return;
				}
			}

			// 处理箱标签信息多余字段
			const printData = this.deepCopy(this.boxPrintData);
			printData.labelAttr = printData.labelAttr.map((item) => {
				return {
					labelCode: item.labelCode,
					labelName: item.labelName,
					value: item.value,
				};
			});

			this.checkDetailList = [];

			if (this.submitForm("deliveryInData")) {
				// console.log("boxPrintData", this.boxPrintData)
				this.$http
					.request({
						url: "/api/boxPrint/insertBoxPrint",
						method: "POST",
						showLoading: true,
						data: printData,
						params: {
							person: localStorage.getItem("user"),
						},
					})
					.then((resp) => {
						if (resp.status == 100) {
							this.$notify({
								title: "成功",
								message: "新增成功！",
								type: "success",
							});
							this.logRemarks = "boxPrint箱标签打印新增成功";
							this.editBoxShow = false;
							this.getBoxAttr();

							for (var index in resp.data) {
								var i = 0;
								while (i < printData.onePrintQuan) {
									this.checkDetailList.push(resp.data[index]);
									i++;
								}
							}

							console.log(this.checkDetailList);
							let LODOP = this.printInit(this.checkDetailList);
							//打印
							LODOP.PRINT();
						} else {
							this.$notify.error({
								title: "失败",
								message: resp.message,
							});
							this.logRemarks = "boxPrint箱标签打印新增失败";
						}
						// this.logContent =
						// this.systemLog();
						//this.colsePrint();
					})
					.catch((error) => {
						this.$notify.error({
							title: "失败",
							message: "调用失败",
						});
					}).finally(() => {
						// 清空页面数据
						this.colsePrint(false)
					})
			}
		},
		//直接打印
		print(type) {
			console.log("打印11111111");
			debugger;
			if (this.checkDetailList.length == 0) {
				this.$message({
					message: "请勾选打印单！",
					type: "warning",
				});
				return;
			}
			//无码时添加打印限制
			if (this.lazyNext) {
				this.$message.error("请五秒后再打印！");
				return;
			} else {
				console.log(this.checkDetailList);
				let LODOP = this.printInit(this.checkDetailList, type);
				//预览
				LODOP.PRINT();
			}
		},
		//预览
		printLook(type) {
			console.log("预览1111111111");
			if (this.checkDetailList.length == 0) {
				this.$message({
					message: "请勾选打印单！",
					type: "warning",
				});
				return;
			}
			//无码时添加打印限制
			if (this.lazyNext) {
				this.$message.error("请五秒后再打印！");
				return;
			} else {
				console.log("选中数据:", this.checkDetailList);
				let LODOP = this.printInit(this.checkDetailList, type);
				//预览
				LODOP.PREVIEW();
			}
		},
		//设置打印参数
		printInit(data, type) {
			if (false) {
			let barCodePrintInfo = this.barcodePrintData;
			// 箱标签打印取订单数据
			let orderForm = this.boxPrintData;
			let toAddress = "";
			let fcCode = "";
			if (this.barcodePrintData.fcCode != undefined) {
				toAddress = barCodePrintInfo.fcCode == "DLM" ? "铁山东三路53号" : "淮河中路87号";
				fcCode = barCodePrintInfo.fcCode;
			} else {
				toAddress = this.lineNoList[0].fcCode == "DLM" ? "铁山东三路53号" : "淮河中路87号";
				fcCode = this.lineNoList[0].fcCode;
			}
			let printTime = moment().format("YYYY-MM-DD HH:mm:ss");
			let printList = data.map((item) => {
				var produceTime = moment(item.matProduceTime).format("YYYYMMDD");
				// 原新昌规则
				//   var qrCode = item.boxCode + "," + barCodePrintInfo.orderCode + "," + barCodePrintInfo.whCode + "," +
				//       barCodePrintInfo.matCode + "," + item.matQuan + "," + item.specs +
				//       "," + item.orderCode + "," + produceTime + "," + item.boxHeight + "," +
				//       item.steelCode + "," + item.rolledSteelCode + "," + item.forgeCode;
				//   更新qrCode生成规则 订单号+物料编号+箱数（默认1）+供应商+通道+总数量+供应商名称+生产日期+批次+状态+图纸版本号+供应商追溯号+箱号+锻造供应商+锻造炉号+钢材炉号+钢号+围板类型+发货日期+公差
				// 20250321 6箱号boxCode与12供应商supplier索引对调
				var qrCode =
					(item.orderCode || orderForm.orderCode) +
					",;" +
					(item.matCode || orderForm.matCode) +
					",;1,;" +
					item.supplierRetrospectCode +
					",;" +
					item.whCode +
					",;" +
					item.matQuan +
					",;" +
					item.supplier +
					",;" +
					item.matTime +
					",;" +
					item.batchNo +
					",;" +
					item.status +
					",;" +
					item.drawCode +
					",;" +
					item.traceability +
					",;" +
					item.boxCode +
					",;" +
					item.forgeSupplierCode +
					",;" +
					item.forgeCode +
					",;" +
					item.rolledSteelCode +
					",;" +
					item.steelCode +
					",;" +
					item.coamingType +
					",;" +
					item.storeIssueTime +
					",;" +
					item.specs;
				qrCode = qrCode.replaceAll("undefined", "");
				// P247244,YY010006,1,供应商,800,200,供应商名称,2025-03-18,批次,状态,图纸版本号,供应商追溯号,BX25031800184,锻造供应商,锻造炉号,钢材炉号,钢号,围版类型,,公差
				return {
					gyCode: item.supplierRetrospectCode,
					gyName: item.supplier,
					//送货地址
					toAddress: "斯凯孚大连轴承与精密技术有限公司",
					address: toAddress,
					//物料型号
					wlType: item.matCode,
					//批次
					pc: item.batchNo,
					//追溯
					zs: item.supplierRetrospectCode,
					//订单好
					orderNo: item.orderCode,
					//发料日期
					// flDate:moment(item.store_issue_time).format("YYYYMMDD"),
					//通道
					td: item.whCode,
					//图纸号
					imgNo: item.drawCode,
					//数量
					num: item.matQuan,
					//钢材炉号
					gcLN: item.rolledSteelCode,
					//钢号
					gcNo: item.steelCode,
					//热处理号
					rcNo: item.heatTreatmentCode,
					//表面处理号
					bmcNo: item.surfaceCode,
					//锻造供应商
					dzGY: item.forgeSupplierCode,
					//锻造炉号
					dzNo: item.forgeCode,
					//打印日期
					dyDate: printTime,
					//二维码
					qrCode: qrCode,
					//包装箱号
					boxBarcode: item.boxCode,
					//工厂
					//fcCode: barCodePrintInfo.fcCode
					fcCode: fcCode,
					// 物料名称
					wlName: item.matName,
					// 公差
					gc: item.specs,
					// 发货日期
					fhDate: moment(item.storeIssueTime).format("YYYYMMDD"),
					// 围板类型
					wbType: item.coamingType,
					// 供应商追溯号
					gyTrace: item.traceability,
					// 图纸版本号
					tzVersion: item.drawCode,
					// 状态
					zt: item.status,
				};
			});
			}
			console.log("打印信息:", data);
			let LODOP = getLodop();
			LODOP.PRINT_INIT("标签打印");
			data.forEach((item) => {
				//强制分页
				LODOP.NEWPAGE();
				//设置打印样式
                // if(type === 'A5'){
                //     this.setPrintStyA5(LODOP, item);
                // }else{
                //     this.setPrintStyNormal(LODOP, item, type);
                // }
	 			const params = printParamsFormat(item, { boxBarcode: 'boxCode', gyCode: 'supplierRetrospectCode' })
                //设置打印样式
				printBoxBarcode(params, LODOP, type)
			});
			return LODOP;
		},
		//设置打印格式
		setPrintStyA5(LODOP, param) {
			//设置纸张大小  以下样式按照原始大小为138*105绘制，后缩放
			// LODOP.SET_PRINT_PAGESIZE(1, "100mm", "79mm", "");
			var width = 148
			var height = 210

            const offsetX = 8
            // 设置打印内容缩放比例（可选）
			LODOP.SET_PRINT_PAGESIZE(2, width + "mm", height + "mm", "");

			//设置标题行属性
			LODOP.ADD_PRINT_RECT("1mm", `${1+offsetX}mm`, "136mm", "8mm", 0, 1); //边框
			LODOP.ADD_PRINT_TEXTA("title", "2mm", `${25+offsetX}mm`, "70mm", "8mm", "STOCK LABEL SKF NK");
			LODOP.SET_PRINT_STYLEA("title", "FontSize", 18);
			LODOP.SET_PRINT_STYLEA("title", "Alignment", 2);
			LODOP.SET_PRINT_STYLEA("title", "Bold", 1);

			//供应商名称
			LODOP.ADD_PRINT_RECT("9mm", `${1+offsetX}mm`, "68mm", "17mm", 0, 1); //边框
			LODOP.ADD_PRINT_TEXTA("gyName", "11mm", `${2+offsetX}mm`, "68mm", "8mm", " From 供应商:");
			LODOP.ADD_PRINT_TEXTA("gyName", "17mm", `${2+offsetX}mm`, "68mm", "8mm", " " + param.gyCode);
			LODOP.SET_PRINT_STYLEA("gyName", "FontSize", 14);
			LODOP.SET_PRINT_STYLEA("gyName", "Alignment", 1);
			// 送货地点
			LODOP.ADD_PRINT_RECT("9mm", `${69+offsetX}mm`, "68mm", "17mm", 0, 1); //边框
			// LODOP.ADD_PRINT_TEXTA("toAddress", "11mm", "70mm", "68mm", "8mm", param.fcCode == 'DLM' ? " To 送货地点:(MSB)" : " To 送货地点:(LSB)")
			// LODOP.ADD_PRINT_TEXTA("toAValue", "17mm", "70mm", "68mm", "8mm", " " + param.toAddress + '(' + param.address + ')')
			LODOP.ADD_PRINT_TEXTA("toAddress", "11mm", `${70+offsetX}mm`, "68mm", "8mm", " To 送货地点:(NKO)");
			LODOP.ADD_PRINT_TEXTA(
				"toAValue",
				"17mm",
				`${70+offsetX}mm`,
				"68mm",
				"8mm",
				" 北京南口斯凯孚铁路轴承有限公司"
			);
			LODOP.SET_PRINT_STYLEA("toAddress", "FontSize", 14);
			LODOP.SET_PRINT_STYLEA("toAddress", "Alignment", 1);

			//设置二维码 QRCode指定二维码格式
			LODOP.ADD_PRINT_RECT("26mm", `${1+offsetX}mm`, "45mm", "78mm", 0, 1); //边框
			LODOP.ADD_PRINT_BARCODE("38mm", `${6+offsetX}mm`, "44mm", "46mm", "QRCode", param.qrCode);
			// 标签打印时间
			LODOP.ADD_PRINT_TEXTA("bqdyDate", "83mm", `${4+offsetX}mm`, "30mm", "8mm", "标签打印时间");
			LODOP.ADD_PRINT_TEXTA("bqdyValue", "90mm", `${-6+offsetX}mm`, "45mm", "8mm", param.dyDate);
			LODOP.SET_PRINT_STYLEA("bqdyDate", "FontSize", 12);
			LODOP.SET_PRINT_STYLEA("bqdyDate", "Alignment", 2);
			LODOP.SET_PRINT_STYLEA("bqdyValue", "FontSize", 12);
			// LODOP.SET_PRINT_STYLEA("bqdyValue","Bold", 1);
			LODOP.SET_PRINT_STYLEA("bqdyValue", "Alignment", 2);

			// 箱号+订单号+通道+物料型号+物料名称+每箱数量 top left width height
			LODOP.ADD_PRINT_RECT("26mm", `${46+offsetX}mm`, "91mm", "39mm", 0, 1); // 边框
			LODOP.ADD_PRINT_TEXTA("contentKey", "29mm", `${47+offsetX}mm`, "14mm", "6mm", "箱号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "29mm", `${61+offsetX}mm`, "75mm", "6mm", param.boxBarcode);
			LODOP.ADD_PRINT_TEXTA("contentKey", "35mm", `${47+offsetX}mm`, "19mm", "6mm", "订单号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "35mm", `${66+offsetX}mm`, "70mm", "6mm", param.orderNo);
			LODOP.ADD_PRINT_TEXTA("contentKey", "41mm", `${47+offsetX}mm`, "14mm", "6mm", "通道:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "41mm", `${61+offsetX}mm`, "75mm", "6mm", param.td);
			LODOP.ADD_PRINT_TEXTA("contentKey", "47mm", `${47+offsetX}mm`, "24mm", "6mm", "物料编号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "47mm", `${71+offsetX}mm`, "65mm", "6mm", param.wlType);
			LODOP.ADD_PRINT_TEXTA("contentKey", "53mm", `${47+offsetX}mm`, "24mm", "6mm", "物料名称:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "53mm", `${71+offsetX}mm`, "75mm", "6mm", param.wlName);
			LODOP.ADD_PRINT_TEXTA("contentKey", "59mm", `${47+offsetX}mm`, "24mm", "6mm", "每箱数量:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "59mm", `${71+offsetX}mm`, "65mm", "6mm", param.num);

			// 公差+批次+发货日期+围板类型+钢号+钢材炉号
			LODOP.ADD_PRINT_RECT("65mm", `${46+offsetX}mm`, "42mm", "39mm", 0, 1); // 边框
			LODOP.ADD_PRINT_TEXTA("contentKey", "68mm", `${47+offsetX}mm`, "13mm", "6mm", "公差:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "68mm", `${60+offsetX}mm`, "32mm", "6mm", param.gc);
			LODOP.ADD_PRINT_TEXTA("contentKey", "74mm", `${47+offsetX}mm`, "13mm", "6mm", "批次:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "74mm", `${60+offsetX}mm`, "32mm", "6mm", param.pc);
			LODOP.ADD_PRINT_TEXTA("contentKey", "80mm", `${47+offsetX}mm`, "22mm", "6mm", "发货日期:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "80mm", `${67+offsetX}mm`, "25mm", "6mm", param.fhDate);
			LODOP.ADD_PRINT_TEXTA("contentKey", "86mm", `${47+offsetX}mm`, "22mm", "6mm", "围板类型:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "86mm", `${69+offsetX}mm`, "23mm", "6mm", param.wbType);
			LODOP.ADD_PRINT_TEXTA("contentKey", "92mm", `${47+offsetX}mm`, "13mm", "6mm", "钢号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "92mm", `${60+offsetX}mm`, "32mm", "6mm", param.gcNo);
			LODOP.ADD_PRINT_TEXTA("contentKey", "98mm", `${47+offsetX}mm`, "22mm", "6mm", "钢材炉号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "98mm", `${69+offsetX}mm`, "23mm", "6mm", param.gcLN);

			LODOP.ADD_PRINT_RECT("65mm", `${88+offsetX}mm`, "49mm", "39mm", 0, 1); // 边框
			LODOP.ADD_PRINT_TEXTA("contentKey", "68mm", `${89+offsetX}mm`, "22mm", "6mm", "锻造炉号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "68mm", `${110+offsetX}mm`, "31mm", "6mm", param.dzNo);
			LODOP.ADD_PRINT_TEXTA("contentKey", "74mm", `${89+offsetX}mm`, "26mm", "6mm", "锻造供应商:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "74mm", `${114+offsetX}mm`, "27mm", "6mm", param.dzGY);
			LODOP.ADD_PRINT_TEXTA("contentKey", "80mm", `${89+offsetX}mm`, "26mm", "6mm", "供应商名称:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "80mm", `${114+offsetX}mm`, "27mm", "6mm", param.gyName);
			LODOP.ADD_PRINT_TEXTA("contentKey", "86mm", `${89+offsetX}mm`, "31mm", "6mm", "供应商追溯号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "86mm", `${118+offsetX}mm`, "22mm", "6mm", param.gyTrace);
			LODOP.ADD_PRINT_TEXTA("contentKey", "92mm", `${89+offsetX}mm`, "26mm", "6mm", "图纸版本号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "92mm", `${114+offsetX}mm`, "23mm", "6mm", param.tzVersion);
			LODOP.ADD_PRINT_TEXTA("contentKey", "98mm", `${89+offsetX}mm`, "13mm", "6mm", "状态:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "98mm", `${102+offsetX}mm`, "36mm", "6mm", param.zt);

			// 项目名样式
			LODOP.SET_PRINT_STYLEA("contentKey", "FontSize", 12);
			LODOP.SET_PRINT_STYLEA("contentKey", "Alignment", 1);
			// 项目值样式
			LODOP.SET_PRINT_STYLEA("contentValue", "FontSize", 12);
			LODOP.SET_PRINT_STYLEA("contentValue", "Alignment", 1);
			LODOP.SET_PRINT_STYLEA("contentValue", "Bold", 1);

			LODOP.SET_PRINT_STYLE('FontName', '黑体')
            // LODOP.SET_PRINT_MODE("Landscape", false)
			LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", '132%');

			// LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Full-Width");
			// LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Full-Height");
			// LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", 'Auto-Height');
            // LODOP.SET_PRINT_PAGESIZE(intOrient,intPageWidth,intPageHeight,strPageName);
			return LODOP;
		},
		//设置打印格式
		setPrintStyNormal(LODOP, param, type) {
			//设置纸张大小  以下样式按照原始大小为138*105绘制，后缩放
			// LODOP.SET_PRINT_PAGESIZE(1, "100mm", "79mm", "");
			const originWidth = 138
			const originHeight = 105
			var width = 100
			var height = 79
			LODOP.SET_PRINT_PAGESIZE(1, width + "mm", height + "mm", "");
			const radio = Math.min(width / originWidth, height / originHeight)

			//设置标题行属性
			LODOP.ADD_PRINT_RECT("1mm", "1mm", "136mm", "8mm", 0, 1); //边框
			LODOP.ADD_PRINT_TEXTA("title", "2mm", "46mm", "70mm", "8mm", "STOCK LABEL SKF NK");
			LODOP.SET_PRINT_STYLEA("title", "FontSize", 18);
			LODOP.SET_PRINT_STYLEA("title", "Alignment", 2);
			LODOP.SET_PRINT_STYLEA("title", "Bold", 1);

			//供应商名称
			LODOP.ADD_PRINT_RECT("9mm", "1mm", "68mm", "17mm", 0, 1); //边框
			LODOP.ADD_PRINT_TEXTA("gyName", "11mm", "2mm", "68mm", "8mm", " From 供应商:");
			LODOP.ADD_PRINT_TEXTA("gyName", "17mm", "2mm", "68mm", "8mm", " " + param.gyCode);
			LODOP.SET_PRINT_STYLEA("gyName", "FontSize", 14);
			LODOP.SET_PRINT_STYLEA("gyName", "Alignment", 1);
			// 送货地点
			LODOP.ADD_PRINT_RECT("9mm", "69mm", "68mm", "17mm", 0, 1); //边框
			// LODOP.ADD_PRINT_TEXTA("toAddress", "11mm", "70mm", "68mm", "8mm", param.fcCode == 'DLM' ? " To 送货地点:(MSB)" : " To 送货地点:(LSB)")
			// LODOP.ADD_PRINT_TEXTA("toAValue", "17mm", "70mm", "68mm", "8mm", " " + param.toAddress + '(' + param.address + ')')
			LODOP.ADD_PRINT_TEXTA("toAddress", "11mm", "70mm", "68mm", "8mm", " To 送货地点:(NKO)");
			LODOP.ADD_PRINT_TEXTA(
				"toAValue",
				"17mm",
				"70mm",
				"68mm",
				"8mm",
				" 北京南口斯凯孚铁路轴承有限公司"
			);
			LODOP.SET_PRINT_STYLEA("toAddress", "FontSize", 14);
			LODOP.SET_PRINT_STYLEA("toAddress", "Alignment", 1);

			//设置二维码 QRCode指定二维码格式
			LODOP.ADD_PRINT_RECT("26mm", "1mm", "45mm", "78mm", 0, 1); //边框
			LODOP.ADD_PRINT_BARCODE("38mm", "6mm", "44mm", "46mm", "QRCode", param.qrCode);
			// 标签打印时间
			LODOP.ADD_PRINT_TEXTA("bqdyDate", "83mm", type==='A5' ? "4mm" : "10mm", "40mm", "8mm", "标签打印时间");
			LODOP.ADD_PRINT_TEXTA("bqdyValue", "90mm", type==='A5' ? "1mm" : "8mm", "45mm", "8mm", param.dyDate);
			LODOP.SET_PRINT_STYLEA("bqdyDate", "FontSize", 12);
			LODOP.SET_PRINT_STYLEA("bqdyDate", "Alignment", 2);
			LODOP.SET_PRINT_STYLEA("bqdyValue", "FontSize", 12);
			// LODOP.SET_PRINT_STYLEA("bqdyValue","Bold", 1);
			LODOP.SET_PRINT_STYLEA("bqdyValue", "Alignment", 2);

			// 箱号+订单号+通道+物料型号+物料名称+每箱数量 top left width height
			LODOP.ADD_PRINT_RECT("26mm", "46mm", "91mm", "39mm", 0, 1); // 边框
			LODOP.ADD_PRINT_TEXTA("contentKey", "29mm", "47mm", "14mm", "6mm", "箱号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "29mm", "61mm", "75mm", "6mm", param.boxBarcode);
			LODOP.ADD_PRINT_TEXTA("contentKey", "35mm", "47mm", "19mm", "6mm", "订单号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "35mm", "66mm", "70mm", "6mm", param.orderNo);
			LODOP.ADD_PRINT_TEXTA("contentKey", "41mm", "47mm", "14mm", "6mm", "通道:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "41mm", "61mm", "75mm", "6mm", param.td);
			LODOP.ADD_PRINT_TEXTA("contentKey", "47mm", "47mm", "24mm", "6mm", "物料编号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "47mm", "71mm", "65mm", "6mm", param.wlType);
			LODOP.ADD_PRINT_TEXTA("contentKey", "53mm", "47mm", "24mm", "6mm", "物料名称:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "53mm", "71mm", "75mm", "6mm", param.wlName);
			LODOP.ADD_PRINT_TEXTA("contentKey", "59mm", "47mm", "24mm", "6mm", "每箱数量:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "59mm", "71mm", "65mm", "6mm", param.num);

			// 公差+批次+发货日期+围板类型+钢号+钢材炉号
			LODOP.ADD_PRINT_RECT("65mm", "46mm", "42mm", "39mm", 0, 1); // 边框
			LODOP.ADD_PRINT_TEXTA("contentKey", "68mm", "47mm", "13mm", "6mm", "公差:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "68mm", "60mm", "32mm", "6mm", param.gc);
			LODOP.ADD_PRINT_TEXTA("contentKey", "74mm", "47mm", "13mm", "6mm", "批次:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "74mm", "60mm", "32mm", "6mm", param.pc);
			LODOP.ADD_PRINT_TEXTA("contentKey", "80mm", "47mm", "22mm", "6mm", "发货日期:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "80mm", "67mm", "25mm", "6mm", param.fhDate);
			LODOP.ADD_PRINT_TEXTA("contentKey", "86mm", "47mm", "22mm", "6mm", "围板类型:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "86mm", "69mm", "23mm", "6mm", param.wbType);
			LODOP.ADD_PRINT_TEXTA("contentKey", "92mm", "47mm", "13mm", "6mm", "钢号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "92mm", "60mm", "32mm", "6mm", param.gcNo);
			LODOP.ADD_PRINT_TEXTA("contentKey", "98mm", "47mm", "22mm", "6mm", "钢材炉号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "98mm", "69mm", "23mm", "6mm", param.gcLN);

			LODOP.ADD_PRINT_RECT("65mm", "88mm", "49mm", "39mm", 0, 1); // 边框
			LODOP.ADD_PRINT_TEXTA("contentKey", "68mm", "89mm", "22mm", "6mm", "锻造炉号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "68mm", "110mm", "31mm", "6mm", param.dzNo);
			LODOP.ADD_PRINT_TEXTA("contentKey", "74mm", "89mm", "26mm", "6mm", "锻造供应商:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "74mm", "114mm", "27mm", "6mm", param.dzGY);
			LODOP.ADD_PRINT_TEXTA("contentKey", "80mm", "89mm", "26mm", "6mm", "供应商名称:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "80mm", "114mm", "27mm", "6mm", param.gyName);
			LODOP.ADD_PRINT_TEXTA("contentKey", "86mm", "89mm", "31mm", "6mm", "供应商追溯号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "86mm", "118mm", "22mm", "6mm", param.gyTrace);
			LODOP.ADD_PRINT_TEXTA("contentKey", "92mm", "89mm", "26mm", "6mm", "图纸版本号:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "92mm", "114mm", "23mm", "6mm", param.tzVersion);
			LODOP.ADD_PRINT_TEXTA("contentKey", "98mm", "89mm", "13mm", "6mm", "状态:");
			LODOP.ADD_PRINT_TEXTA("contentValue", "98mm", "102mm", "36mm", "6mm", param.zt);

			// 项目名样式
			LODOP.SET_PRINT_STYLEA("contentKey", "FontSize", 12);
			LODOP.SET_PRINT_STYLEA("contentKey", "Alignment", 1);
			// 项目值样式
			LODOP.SET_PRINT_STYLEA("contentValue", "FontSize", 12);
			LODOP.SET_PRINT_STYLEA("contentValue", "Alignment", 1);
			LODOP.SET_PRINT_STYLEA("contentValue", "Bold", 1);

			LODOP.SET_PRINT_STYLE('FontName', '黑体')
			// 缩放以适应纸张大小
			// LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Full-Page");
			LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", Math.floor(radio * 100) +'%');
			// LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Full-Width");
			// LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT", "Full-Height");
			return LODOP;
		},
		//打印动态设置
		changePrintSty(i, param, LODOP) {
			console.log("动态加载index:", i);
			//有于是为单数 设置第一个行元素
			let index = parseInt(i / 2);
			if (i % 2 > 0) {
				let height = 82 + index * 8 + "mm";
				LODOP.ADD_PRINT_TEXTA("changeSty_" + i, height, "48mm", "45mm", "8mm", param); //标题+值
			} else {
				index--;
				let height = 82 + index * 8 + "mm";
				LODOP.ADD_PRINT_TEXTA("changeSty_" + i, height, "93mm", "45mm", "8mm", param); //标题+值
			}
			LODOP.SET_PRINT_STYLEA("changeSty_" + i, "FontSize", 12);
			LODOP.SET_PRINT_STYLEA("changeSty_" + i, "Alignment", 1);
		},
		/**
		 * 多选
		 */
		selectAllDetail(val) {
			this.checkDetailList = val;
			// console.log("=============", val);
		},

		// 节流搜索
		saveSearch() {
			if (window.lazy) window.clearTimeout(window.lazy);
			window.lazy = window.setTimeout(() => {
				this.clickSelectList();
			}, 1000);
		},

		//打开间材库入库明细窗口
		showAuxiStockDetailDialog(data) {
			this.auxiStockDetailDialog = true;
			this.getBoxDetails(data.printId);
			this.barcodePrintData = data;
		},
		deleteHandle(printId){
			this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.ifDelete(printId)
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		// 删除箱标签
		ifDelete(printId) {
			this.$http
				.request({
					url: "/api/boxPrint/deleteBoxPrint",
					method: "GET",
					params: {
						printId
					},
				})
				.then((res) => {
					if (res.status == 100) {
						this.getBoxAttr();
						this.$message.success('删除箱标签成功')
					}
				})
		},
		//关闭间材库明细窗口
		closeAuxiStockDetailDialog() {
			this.auxiStockDetailData.data = [];
			this.auxiStockDetailDialog = false;
		},

		// 点击查询按钮 重置页号
		clickSelectList(newVal) {
			this.getBoxAttr(newVal);
		},
		/**
		 * 获取箱标签记录
		 */
		getBoxAttr() {
			this.$http
				.request({
					url: "/api/boxPrint/getBoxPrintAll",
					method: "GET",
					params: {
						pageNum: this.boxMainData.nowPage, // 页号
						pageSize: this.boxMainData.pageSize, // 页大小
						orderCode: this.mainSearch.orderCode || null,
						lineNo: this.mainSearch.lineNo || null,
						supplier: this.mainSearch.supplier || null,
						matCode: this.mainSearch.matCode || null,
						person: localStorage.getItem("user"),
						beginTime: this.mainSearch.beginTime || null,
						endTime: this.mainSearch.endTime || null,
					},
				})
				.then((res) => {
					if (res.status == 100) {
						this.boxMainData.data = res.data.list;
						this.boxMainData.total = res.data.total;
					} else {
						this.$message.error("错误");
					}
				});
		},
		/**
		 * 获取箱标签记录详情
		 */
		getBoxDetails(printId) {
			this.$http
				.request({
					url: "/api/boxPrint/getBoxAtter",
					method: "GET",
					params: {
						printId: printId || null,
					},
				})
				.then((res) => {
					if (res.status == 100) {
						this.boxDetailData.data = res.data.list;
						this.boxDetailData.total = res.data.total;
					} else {
						this.$message.error("错误");
					}
				});
		},

		/**
		 * 获取间材库入库记录
		 */
		getAuxiStockData() {
			this.$http
				.request({
					url: "/api/order/getOrderPurchaseList",
					method: "GET",
					params: {
						pageNum: this.mainData.nowPage, //	页号
						pageSize: this.mainData.pageSize, //	页大小
						fcCode: this.mainSearch.fcCode || null, //	工厂编号
						sasCode: this.mainSearch.sasCode || null, //	间材库入库编号
						matCode: this.mainSearch.matCode || null, //	物料编号
						matName: this.mainSearch.matName || null, // 物料描述
						status: this.mainSearch.status || null, //	状态
						// person: this.mainSearch.person || null, //操作员
						beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null,
						endTime: this.mainSearch.date ? this.mainSearch.date[1] : null,
						//whCode: this.mainSearch.whCode || null,
						orderCode: this.mainSearch.orderCode,
						wareType: "20",
					},
				})
				.then((res) => {
					if (res.status == 100) {
						this.mainData.data = res.data.list;
						this.mainData.total = res.data.total;
					} else {
						this.$message.error("错误");
					}
				});
		},
		/**
		 * 根据间材库入库编号查询详情
		 */
		getAuxiStockDetail() {
			//根据间材库入库编号获取详细信息
			this.$http
				.request({
					url: "/api/order/getOrderPurchaseDetailList",
					method: "GET",
					params: {
						orderCode: this.orderCode,
					},
				})
				.then((resp) => {
					if (resp.status == 100) {
						this.auxiStockDetailData.data = resp.data.list;
						for (var index in this.auxiStockDetailData.data) {
							this.auxiStockDetailData.data[index].nowQuan = 0;
							this.auxiStockDetailData.data[index].person = this.person;
							this.auxiStockDetailData.data[index].personNumber = this.personNumber;
							this.auxiStockDetailData.data[index].fcCode = this.fcCode;
						}
						this.auxiStockDetailData.total = resp.data.total;
					}
				})
				.catch((error) => {
					this.$message({
						message: "操作失败",
						type: "warning",
					});
				});
		},

		//获取数据
		getOrderDetail(orderCode) {
			this.$http
				.request({
					url: "/api/order/getOrderPurchaseDetailList",
					method: "GET",
					params: {
						orderCode: orderCode,
					},
				})
				.then((resp) => {
					if (resp.status == 100) {
						this.lineNoList = resp.data.list;
					}
				})
				.catch((error) => {
					this.loading++;
				});
		},

		getOrder(orderCode) {
			this.$http
				.request({
					url: "/api/order/getOrderPurchaseList",
					method: "GET",
					params: {
						orderCode: orderCode,
					},
				})
				.then((resp) => {
					if (resp.status == 100) {
						if (resp.data.list == null) {
							this.$message({
								message: "未查到此订单，请确认是否输入正确！或者联系管理是否已同步此订单",
								type: "warning",
							});
							return;
						}
						this.orderPurchaseList = resp.data.list;
						this.getOrderDetail(orderCode);
					}
				})
				.catch((error) => {
					this.loading++;
				});
		},
		colsePrint(close = true) {
			close && (this.boxBarcodePrintDialog = false);
			this.boxPrintData = {
				orderCode: "",
				lineNo: "",
				supplier: "",
				matCode: "",
				matName: "",
				matQuan: "",
				matStandNumber: 0, //每箱箱数
				printQuan: 0,
				onePrintQuan: 1,
				numPrintQuan: "",
				noPrintQuan: "",
				labelAttr: [],
				matCodeQR: "",
				remainingNum: "",
			};
			this.lineNoList = [];
			this.labelAttr = [];
		},
		async getLineNo(lineNo) {
			let orderInfo = this.lineNoList.find((o) => o.lineNo == lineNo);
			this.boxPrintData.matCode = orderInfo.matCode;
			this.boxPrintData.matName = orderInfo.matName;
			this.boxPrintData.matQuan = orderInfo.orderQuan - orderInfo.matArriveQuan;
			this.boxPrintData.supplier = this.orderPurchaseList[0].supplier;
			this.boxPrintData.whCode = orderInfo.whCode;
			this.boxPrintData.fcCode = orderInfo.fcCode;
			// todo 获取装箱数
			// 根据物料编码获取物料类型
			// const targetMat = await this.$http.request({
			//     url: "api/materialType/getMaterialTypeAll",
			//     method: "GET",
			//     params: {
			//         mtCode: this.boxPrintData.matCode,
			//     },
			// })
			// if (targetMat.status !== 100 || !(targetMat.data.list && targetMat.data.list.length)) return this.$message.error('该物料类型未配置')
			// // 根据物料mtId获取标签属性配置
			// const targetAttr = await this.$http.request({
			//     url: "/api/materialType/getLabelMatList",
			//     method: "GET",
			//     params: {
			//         mtId: targetMat.data.list[0].mtId,
			//     },
			// })

			// if (targetAttr.status !== 100 || !(targetAttr.data && targetAttr.data.length)) return this.$message.error('该物料类型打印模板未配置')
			// const attrs = targetAttr.data.filter(item => item.status)
			// if (!attrs.length) return this.$message.error('该物料类型打印模板未配置')
			// attrs.forEach(item => {
			//     this.boxPrintData.labelAttr.push({ labelName: item.labelName, labelCode: item.labelCode, value: '' })
			// })
			// 获取供应商物料装箱数
			const targetMat = await this.$http.request({
				url: "/api/sysMaterialDeploy/getSysMaterialDeploy",
				method: "GET",
				params: {
					prodCode: this.boxPrintData.matCode,
          supplierCode: this.boxPrintData.supplier,
				},
			});
			console.log(targetMat);
			let boxQuantity = 0;
			if (targetMat.status !== 100 || !(targetMat.data.list && targetMat.data.list.length)) {
				boxQuantity = 0;
			} else {
				boxQuantity = targetMat.data.list[0].boxQuantity || 0;
			}
			this.boxPrintData.matStandNumber = boxQuantity;
			this.boxPrintData.printQuan = boxQuantity
				? Math.floor(this.boxPrintData.matQuan / boxQuantity)
				: 0;
			// this.boxPrintData.onePrintQuan = this.boxPrintData.printQuan || 1
			// 获取箱标签信息
			this.$http
				.request({
					url: "/api/vendorLabel/getMatLabel",
					method: "GET",
					params: {
						matCode: this.boxPrintData.matCode,
						vendorCode: this.boxPrintData.supplier,
					},
				})
				.then((resp) => {
					if (resp.status == 100) {
						this.labelAttrList = resp.data.list;

						this.labelAttrList.forEach((item) => {
							const obj = {
								type: "normal",
								labelName: item.labelName,
								value: "",
								labelCode: item.labelCode,
							};
							// 标签属性特殊项处理
							// 发货日期默认当天
							if (item.labelCode == "deliveryDate") {
								obj.type = "date";
								obj.value = moment().format("YYYY-MM-DD");
							}
							// 围板类型
							if (item.labelCode == "weiType") {
								obj.type = "select";
								obj.options = [
									{
										label: "P01",
										value: "P01",
									},
									{
										label: "P02",
										value: "P02",
									},
									{
										label: "P03",
										value: "P03",
									},
									{
										label: "P04",
										value: "P04",
									},
									{
										label: "P06",
										value: "P06",
									},
									{
										label: "P50",
										value: "P50",
									},
									{
										label: "P100",
										value: "P100",
									},
									{
										label: "P236",
										value: "P236",
									},
									{
										label: "纸箱",
										value: "纸箱",
									},
									{
										label: "托盘",
										value: "托盘",
									},
								];
							}
							// 状态
							if (item.labelCode == "status") {
								obj.type = "select";
								obj.options = [
									{
										label: "样品",
										value: "样品",
									},
									{
										label: "PPAP",
										value: "PPAP",
									},
									{
										label: "量产",
										value: "量产",
									},
								];
								obj.value = "量产"
							}
							// 锻造炉号、锻造供应商、供应商名称、供应商追溯号、图纸版本号默认值为NA
							if(['forgeHeatNo','forgeSu','suName','suTraceNo','drawingVer','tolerance','steelGrade','steelHeatNo'].includes(item.labelCode)){
								obj.value = "NA"
							}
							this.boxPrintData.labelAttr.push(obj);
						});
					} else {
						this.$message({
							message: resp.message,
							type: "warning",
						});
						return;
					}
				})
				.catch((error) => {
					this.loading++;
				});

			// 获取订单剩余数量
			const resp = await this.$http
				.request({
					url: "/api/boxPrint/remainingNum",
					method: "GET",
					params: {
						orderCode: this.boxPrintData.orderCode,
						matCode: this.boxPrintData.matCode,
					},
				})
			if (resp.status === 100) {
				this.boxPrintData.remainingNum = resp.data || '';
			} else {
				this.boxPrintData.remainingNum = '';
			}
		},
		savePrint() {
			if (this.boxPrintData.matStandNumber == 0 || this.boxPrintData.matStandNumber == undefined) {
				this.$message({
					message: "请输入每箱箱数！",
					type: "warning",
				});
				return;
			}
			if (this.boxPrintData.printQuan == 0 || this.boxPrintData.printQuan == undefined) {
				this.$message({
					message: "请输入打印标签张数！",
					type: "warning",
				});
				return;
			}
			if (this.boxPrintData.onePrintQuan == 0 || this.boxPrintData.onePrintQuan == undefined) {
				this.$message({
					message: "请输入单张打印数量！",
					type: "warning",
				});
				return;
			}

			if (
				this.boxPrintData.matStandNumber * this.boxPrintData.printQuan >
				this.boxPrintData.matQuan
			) {
				this.$message({
					message: "打印数量超过计划数量",
					type: "warning",
				});
				return;
			}

			for (let i in this.boxPrintData.labelAttr) {
				if (this.boxPrintData.labelAttr[i].value == "") {
					this.$message({
						message: this.boxPrintData.labelAttr[i].labelName + "不能为空！",
						type: "warning",
					});
					return;
				}
			}

			if (this.submitForm("deliveryInData")) {
				// console.log("boxPrintData", this.boxPrintData)
				this.$http
					.request({
						url: "/api/boxPrint/insertBoxPrint",
						method: "POST",
						showLoading: true,
						data: this.boxPrintData,
						params: {
							person: localStorage.getItem("user"),
						},
					})
					.then((resp) => {
						if (resp.status == 100) {
							this.$notify({
								title: "成功",
								message: "新增成功！",
								type: "success",
							});
							this.logRemarks = "boxPrint箱标签打印新增成功";
							this.editBoxShow = false;
							this.getBoxAttr();

							this.checkDetailList = resp.data;

							console.log(this.checkDetailList);

							var barCodePrintInfo = this.boxPrintData;

							this.checkDetailList.forEach((item) => {
								var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

								//T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
								// var qrCode = "T/" + barCodePrintInfo.orderCode + "/" + item.boxCode + "/" + barCodePrintInfo.matCode + "/" +
								//     item.matQuan + "/" + barCodePrintInfo.matSpecs + "/" + item.newBatchNo +
								//     "/" + produceTime + "/" + item.boxHeight + "/";

								//箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
								var qrCode =
									item.boxCode +
									"," +
									barCodePrintInfo.orderCode +
									"," +
									barCodePrintInfo.whCode +
									"," +
									barCodePrintInfo.matCode +
									"," +
									item.matQuan +
									"," +
									item.specs +
									"," +
									item.orderCode +
									"," +
									produceTime +
									"," +
									item.boxHeight +
									"," +
									item.steelCode +
									"," +
									item.rolledSteelCode +
									"," +
									item.forgeCode;

								if (item.specs == undefined) {
									item.specs = "";
								}

								var pritnTwo = false;
								if (barCodePrintInfo.onePrintQuan > 1) {
									pritnTwo = true;
								}

								var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
								var barcodeData = {
									boxBarcode: item.boxCode,
									prodCode: barCodePrintInfo.matCode,
									prodName: barCodePrintInfo.matName,
									batchNo: barCodePrintInfo.orderCode,
									count: item.matQuan,
									checkPerson: localStorage.getItem("empNumber"),
									date: produceTime,
									poCode: barCodePrintInfo.orderCode,
									matSpecs: item.specs,
									whCode: barCodePrintInfo.whCode,
									qrCode: qrCode,
									supply: barCodePrintInfo.supplier,
									printTime: printTime,
									steel_code: item.steelCode,
									draw_code: item.drawCode,
									rolled_steel_code: item.rolledSteelCode,
									forge_code: item.forgeCode,
									forge_supplier_code: item.forgeSupplierCode,
									heat_treatment_code: item.heatTreatmentCode,
									surface_code: item.surfaceCode,
									supplier_retrospect_code: item.supplierRetrospectCode,
									printTwo: false,
									printCount: barCodePrintInfo.onePrintQuan,
									supplyName: localStorage.getItem("userName"),
									// fcAddress: localStorage.getItem("fcCode")=='DLM'?'铁山东三路53号':'淮河中路87号',
									fcAddress: barCodePrintInfo.fcCode == "DLM" ? "铁山东三路53号" : "淮河中路87号",
									fcName: "斯凯孚大连轴承与精密技术有限公司",
								};

								this.$printer.printWMSSupplyBarcode(barcodeData);
							});
						} else {
							this.$notify.error({
								title: "失败",
								message: resp.message,
							});
							this.logRemarks = "boxPrint箱标签打印新增失败";
						}
						// this.logContent =
						// this.systemLog();
						this.colsePrint();
					})
					.catch((error) => {
						this.$notify.error({
							title: "失败",
							message: "调用失败",
						});
					});
			}
		},
		//表单验证
		submitForm(formName) {
			let r = Boolean;
			this.$refs[formName].validate((valid) => {
				if (valid) {
					r = true;
				} else {
					r = false;
				}
			});
			return r;
		},

		/**
		 * 重置
		 */
		reset() {
			this.mainSearch = {
				orderCode: "",
				lineNo: "",
				supplier: "",
				matCode: "",
				requireDate: [],
			};
			this.getBoxAttr();
		},

		/**
		 * 操作日志
		 */
		systemLog() {
			let objData = {
				logType: "箱标签打印",
				logContent: this.logRemarks || "",
				//logRemarks: this.logRemarks || "",
				logUser: localStorage.getItem("userName") || "",
			};
			this.$http
				.request({
					url: "api/log/insert",
					method: "POST",
					data: objData,
				})
				.then((resp) => {
					this.logContent = "";
					this.logRemarks = "";
					if (resp.status == 100) {
					}
				})
				.catch((error) => {});
		},

		//标签打印
		rePrintBarcode() {
			if (this.checkDetailList.length == 0) {
				this.$message({
					message: "请勾选打印单！",
					type: "warning",
				});
				return;
			}
			//无码时添加打印限制
			if (this.lazyNext) {
				this.$message.error("请五秒后再打印！");
				return;
			} else {
				var barCodePrintInfo = this.barcodePrintData;

				console.log(this.checkDetailList);

				this.checkDetailList.forEach((item) => {
					var produceTime = moment(item.matProduceTime).format("YYYYMMDD");

					//T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
					// var qrCode = "T/" + barCodePrintInfo.orderCode + "/" + item.boxCode + "/" + barCodePrintInfo.matCode + "/" +
					//     item.matQuan + "/" + barCodePrintInfo.matSpecs + "/" + item.newBatchNo +
					//     "/" + produceTime + "/" + item.boxHeight + "/";

					//箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
					var qrCode =
						item.boxCode +
						"," +
						item.orderCode +
						"," +
						barCodePrintInfo.whCode +
						"," +
						barCodePrintInfo.matCode +
						"," +
						item.matQuan +
						"," +
						item.specs +
						"," +
						item.newBatchNo +
						"," +
						produceTime +
						"," +
						item.boxHeight +
						"," +
						item.steelCode +
						"," +
						item.rolledSteelCode +
						"," +
						item.forgeCode;

					if (item.specs == undefined) {
						item.specs = "";
					}

					var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
					var barcodeData = {
						boxBarcode: item.boxCode,
						prodCode: barCodePrintInfo.matCode,
						prodName: barCodePrintInfo.matName,
						batchNo: item.newBatchNo,
						count: item.matQuan,
						checkPerson: localStorage.getItem("empNumber"),
						date: produceTime,
						poCode: barCodePrintInfo.orderCode,
						matSpecs: item.specs,
						whCode: barCodePrintInfo.whCode,
						qrCode: qrCode,
						supply: barCodePrintInfo.supplier,
						printTime: printTime,
						printTwo: item.printTwo,
						steel_code: item.steelCode,
						draw_code: item.drawCode,
						rolled_steel_code: item.rolledSteelCode,
						forge_code: item.forgeCode,
						forge_supplier_code: item.forgeSupplierCode,
						heat_treatment_code: item.heatTreatmentCode,
						surface_code: item.surfaceCode,
						supplier_retrospect_code: item.supplierRetrospectCode,
						supplyName: localStorage.getItem("userName"),
						// fcAddress: localStorage.getItem("fcCode")=='DLM'?'铁山东三路53号':'淮河中路87号',
						fcAddress: barCodePrintInfo.fcCode == "DLM" ? "铁山东三路53号" : "淮河中路87号",
						fcName: "斯凯孚大连轴承与精密技术有限公司",
					};

					// console.log(barcodeData);

					this.$printer.printWMSSupplyBarcode(barcodeData);
				});

				this.lazyNext = setTimeout(() => {
					this.lazyNext = null;
				}, 5000);
			}
		},
		createPrintQuan() {
			let intNum = undefined;
			if (!this.boxPrintData.matQuan || !this.boxPrintData.matStandNumber) return intNum;
			intNum = Math.floor(this.boxPrintData.matQuan / this.boxPrintData.matStandNumber);
			this.boxPrintData.printQuan = intNum;
			// this.boxPrintData.onePrintQuan = intNum ? intNum : 1
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = "合计";
					return;
				}
				if (column.property === 'totalQuan') {
					const values = data.map((item) => Number(item[column.property]));
					if (
						!values.every((value) => isNaN(value))
					) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
						sums[index];
					}
				}
			});

			return sums;
		},
		//表格导出
		downLoadFile() {
			this.downloadLoading = true;
			var paramsObj = {
				pageNum: 1, // 页号
				pageSize: 99999, // 页大小
				orderCode: this.mainSearch.orderCode || null,
				lineNo: this.mainSearch.lineNo || null,
				supplier: this.mainSearch.supplier || null,
				matCode: this.mainSearch.matCode || null,
				person: localStorage.getItem("user"),
				beginTime: this.mainSearch.beginTime || null,
				endTime: this.mainSearch.endTime || null,
			}

			this.$http
				.request({
					url: "/api/boxPrint/getBoxPrintAll",
					method: "GET",
					params: paramsObj,
				}).then((resp) => {
					resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
						message: '查询失败'
					});
				})
		},
		downLoad(list) {
			import('@/libs/Export2Excel').then(excel => {
				const tHeader = ['工厂编号', '订单编号', '物料编号', '物料名称', '订单数量', '打印总数', '供应商', '每箱数量', '打印标签张数', '单张打印数量', '更新时间', '创建时间', '操作人']
				const filterVal = ['fcCode', 'orderCode', 'matCode', 'matName', 'orderQuan', 'totalQuan', 'supplier', 'standNumber', 'printNumber', 'onePrintNumber', 'updateTime', 'createTime', 'person',]
				const data = this.formatJson(filterVal, list)
				excel.export_json_to_excel({
					header: tHeader,
					data,
					filename: '箱标签打印列表'
				})
				this.logContent = "导出"
				this.logRemarks = "sys_box_barcode_print：导出箱标签打印列表"
				this.systemLog();
				this.downloadLoading = false
			})
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map(v => filterVal.map(j => v[j]))
		},
		// printTemplateChange(val){
		// 	localStorage.setItem('printTemplate', val)
		// }
	},
	activated() {
		/* 获取首页的数据 */
		this.getBoxAttr();
	},
};
</script>

<style lang="scss" scoped>
.div {
	border: 1px solid black;
	width: 90%;
	height: 140px;
	margin-top: 30px;
	border-radius: 10px;
	margin-left: 48px;
	text-align: left;
}

/* .div {
        border: 1px solid black;
        width: 90%;
        height: 140px;
        margin-top: 30px;
        border-radius: 10px;
        margin-left: 48px;
        text-align: left;
    }

    .div1 {
        border: 1px solid black;
        width: 90%;
        height: 140px;
        margin-top: 15px;
        border-radius: 10px;
        margin-left: 48px;
        text-align: left;
    }

    .div2 {
        border: 1px solid black;
        width: 90%;
        height: 100%;
        margin-top: 15px;
        border-radius: 10px;
        margin-bottom: 15px;
        margin-left: 48px;
        text-align: left;

    }

    .div3 {
        border: 1px solid black;
        width: 90%;
        height: 85px;
        margin-top: 15px;
        border-radius: 10px;
        margin-bottom: 30px;
        margin-left: 48px;
        text-align: left;
    } */

.title {
	margin-top: 10px;
	margin-bottom: 5px;
	font-weight: bold;
	margin-left: 20px;
	font-size: 15px;
}
</style>
